var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"wechat-copy",attrs:{"type":"button","data-site-entry":"wechat","aria-live":"polite"},on:{"click":_vm.copy}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }